import { JSXElement } from 'solid-js';
import ClipboardIcon from '~/assets/clipboard-icon.svg';
import { Localized } from '~/i18n';
import { getApiCredentialsTranslationKey } from '~/pages/Settings/utils.ts';

export default function ClientSecretsEmptyState(): JSXElement {
  return (
    <div class="flex flex-col justify-center items-center py-20 gap-4">
      <img
        src={ClipboardIcon}
        class="w-[80px]"
        alt={`No client secret`}
      />
      <p class="text-sm text-fg-muted">
        <Localized
          translationKey={getApiCredentialsTranslationKey('list_empty_state')}
        />
      </p>
      {/*<Button*/}
      {/*  size={`sm`}*/}
      {/*  onClick={() => merged.handleShowModal && merged.handleShowModal(true)}*/}
      {/*>*/}
      {/*  <PlusIcon class={`mr-1`} />*/}
      {/*  <Localized*/}
      {/*    translationKey={getTranslationKey('cta_label_create_webhook')}*/}
      {/*  />*/}
      {/*</Button>*/}
    </div>
  );
}
